import ProCenter from './modules/procenter/procenterMain';
new ProCenter();
